const Posters = () => {
  return (
    <div className="slide-container">
      <div className="poster-slider">
        <div className="slide-track">
          <div className="slide">
            <img
              src="./images/posters/ballerina.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/best-christmas.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/boys-in-the-boat.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/color-purple.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/den-of-thieves-2.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/fight-or-flight.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/godzilla-minus-one.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/jesus-revolution.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/land-of-bad.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/last-supper.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/my-hero.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/ordinary-angels.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/plane.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/radical.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/reagan.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/saw-x.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/songbird.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/sound-of-freedom.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-apprentice.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-boy-and-the-heron.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-chosen.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-hill.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-last-showgirl.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-long-game.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/the-substance.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/unsung-hero.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/wick4.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>

          <div className="slide">
            <img
              src="./images/posters/young-woman-and-the-sea.jpg"
              height="250"
              width="167"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Posters;
